/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react'
import { getBrands } from '../api'
import BrandCard from '../components/BrandCard'
import './NewBrands.css'

function NewBrands() {
    const [brands, setBrands] = useState([])

    useEffect(() => {
        getBrands().then(data => {
            const sorted = (data || [])
                .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))

            const thirtyDaysAgo = new Date()
            thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30)

            const recent = sorted.filter(b => new Date(b.created_at) > thirtyDaysAgo)
            setBrands(recent.length >= 5 ? recent : sorted.slice(0, 20))
        })
    }, [])

    return (
        <div className="new-brands-page">
            <div className="page-header">
                <h1>Newly Added Brands</h1>
                <p> </p>
            </div>
            <div className="brand-grid">
                {brands.map(brand => (
                    <BrandCard
                        key={brand.id}
                        brand={brand}
                    />
                ))}
            </div>
        </div>
    )
}

export default NewBrands
